import { PlainTextContent } from "@shared-kernel/primary/shared/plain-text-content/plain-text-content.content";

interface EquipmentDescriptionDisplayProps {
  description: string;
}

export const EquipmentDescriptionDisplay = ({ description }: EquipmentDescriptionDisplayProps) => {
  return (
    <div className="text-sm">
      <span className="text-muted-foreground">Moyens techniques et pédagogiques :</span>
      <div className="mt-1 max-h-32 overflow-auto rounded-md border border-muted-foreground/20 p-2">
        <PlainTextContent content={description} />
      </div>
    </div>
  );
};
